import { View } from '@olxbr/design-system'
import styled from 'styled-components'
import medias from '../../../util/medias'

export const RuleWrapper = styled(View)`
  width: 100%;
  margin-top: 24px;
  margin-bottom: 16px;
`
